import api from './api';

/**
 * Anhänge laden.
 *
 * Seit der Sicherheitskorrektur verlangen /api/attachments/:id/preview und
 * .../download eine Authentifizierung. Ein blankes fetch() schickt keinen
 * Authorization-Header und bekommt deshalb 401 — genau daran ist die
 * Bildvorschau gescheitert.
 *
 * Zwei Fälle, die sich unterscheiden müssen:
 *   - eigene API  -> über die axios-Instanz (Token + 401-Refresh inklusive)
 *   - R2-Public-URL -> unverändert per fetch; ein Authorization-Header würde
 *     dort nur die CORS-Preflight-Regeln verletzen.
 */
function isOwnApiUrl(url: string): boolean {
  return url.includes('/api/attachments/');
}

export async function fetchAttachmentBlob(url: string): Promise<Blob> {
  if (!isOwnApiUrl(url)) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Attachment request failed (${response.status})`);
    }
    return response.blob();
  }

  // Absolute URL auf den Pfad reduzieren, den die axios-baseURL erwartet:
  // "https://host/api/attachments/<id>/preview" -> "/attachments/<id>/preview"
  const path = url.slice(url.indexOf('/api/attachments/') + '/api'.length);
  const response = await api.get(path, { responseType: 'blob' });
  return response.data as Blob;
}

/** Bequemer Wrapper: liefert direkt eine Object-URL für <img src> o. ä. */
export async function fetchAttachmentObjectUrl(url: string): Promise<string> {
  const blob = await fetchAttachmentBlob(url);
  return URL.createObjectURL(blob);
}
